import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/banners/diktan_pobed.jpg")